// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import RoiKpiPopinDetails from './RoiKpiPopinDetails';
import {
  formatMgr,
  formatRoi,
  formatRoiParam,
  formatTic,
} from '../../../../utils/formatUtils';
import type { RoiBpParams } from '../../../../types/apolloType';

type Props = {
  businessPlan: RoiBpParams,
}

function RoiBpResultDetails(props: Props) {
  return (
    <div className="roi-result-modal">
      <div className="roi-result-detail">
        <div className="roi-result-detail-title">
          <RoiKpiPopinDetails
            kpiValue={formatRoi(props.businessPlan.roi)}
            label={<Translate value="roi.kpi.roi" />}
            isFocus={false}
            hideInfoBox
          />
        </div>
        <RoiKpiPopinDetails kpiValue="=" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatMgr(props.businessPlan.mgrUplift)} label={<Translate value="roi.kpi.mgr" />} isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue="/" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatRoiParam(props.businessPlan.tic)} label={<Translate value="roi.kpi.tic" />} isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue="*" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue="100" label={<Translate value="roi.toPercentage" />} isFocus={false} hideInfoBox />
      </div>
      <div className="roi-result-detail">
        <div className="roi-result-detail-title">
          <RoiKpiPopinDetails
            kpiValue={props.businessPlan.payback}
            label={<Translate value="roi.kpi.payback" />}
            isFocus={false}
            hideInfoBox={false}
          />
        </div>
        <RoiKpiPopinDetails kpiValue="=" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatRoiParam(props.businessPlan.tic)} label={<Translate value="roi.kpi.tic" />} isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue="/" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatMgr(props.businessPlan.mgrUplift)} label={<Translate value="roi.kpi.mgr" />} isFocus={false} hideInfoBox />
      </div>
      <div className="roi-result-detail">
        <div className="roi-result-detail-title">
          <RoiKpiPopinDetails
            kpiValue={formatMgr(props.businessPlan.mgrUplift)}
            label={<Translate value="roi.kpi.mgr" />}
            isFocus={props.focus === 'mgr'}
            isPositive={props.businessPlan.isMgrPositive}
            hideInfoBox={false}
          />
        </div>
        <RoiKpiPopinDetails kpiValue="=" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatRoiParam(props.businessPlan.newMgrGlaNet)} label={<Translate value="roi.kpi.newMgrGlaNet" />} isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue="-" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatRoiParam(props.businessPlan.oldMgrGlaNet)} label={<Translate value="roi.kpi.oldMgrGlaNet" />} isFocus={false} hideInfoBox />
      </div>
      <div className="roi-result-detail">
        <div className="roi-result-detail-title">
          <RoiKpiPopinDetails
            kpiValue={formatRoiParam(props.businessPlan.tic)}
            label={<Translate value="roi.kpi.tic" />}
            isFocus={false}
            hideInfoBox={false}
          />
        </div>
        <RoiKpiPopinDetails kpiValue="=" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatTic(props.businessPlan.keyMoney)} label={<Translate value="roi.kpi.keyMoney" />} isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue="+" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatRoiParam(props.businessPlan.evictionCost)} label={<Translate value="roi.params.evictionCost" />} isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue="+" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatRoiParam(props.businessPlan.foc)} label={<Translate value="roi.params.foc" />} isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue="+" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatRoiParam(props.businessPlan.incentives)} label={<Translate value="roi.kpi.Incentives" />} isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue="+" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatTic(props.businessPlan.estimatedLeasingFees)} label={<Translate value="roi.category.estimatedLeasingFees" />} isFocus={false} hideInfoBox isEstimated />
        <RoiKpiPopinDetails kpiValue="+" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatTic(props.businessPlan.estimatedLossOfRent)} label={<Translate value="roi.params.estimatedLossOfRent" />} isFocus={false} hideInfoBox isEstimated />
        <RoiKpiPopinDetails kpiValue="+" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatTic(props.businessPlan.estimatedVacancyCharges)} label={<Translate value="roi.params.estimatedVacancyCharges" />} isFocus={false} hideInfoBox isEstimated />
      </div>
      <div className="roi-result-detail">
        <div className="roi-result-detail-title">
          <RoiKpiPopinDetails
            kpiValue={formatRoiParam(props.businessPlan.valueCreationVsCurrent)}
            label={<Translate value="roi.kpi.valueCreationVsCurrent" />}
            isFocus={false}
            hideInfoBox={false}
          />
        </div>
        <RoiKpiPopinDetails kpiValue="= (" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatMgr(props.businessPlan.mgrUplift)} label={<Translate value="roi.kpi.mgr" />} isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue="/ (" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={props.businessPlan.estimatedExitCap} label={<Translate value="roi.params.estimatedExitCap" />} isFocus={false} hideInfoBox isEstimated />
        <RoiKpiPopinDetails kpiValue="-" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={formatRoiParam(props.businessPlan.tic)} label={<Translate value="roi.kpi.tic" />} isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue=") ) / ( 1 +" label=" " isFocus={false} hideInfoBox />
        <RoiKpiPopinDetails kpiValue={props.businessPlan.estimatedTransferTaxAndTransactionCosts} label={<Translate value="roi.params.estimatedTransferTaxAndTransactionCosts" />} isFocus={false} hideInfoBox isEstimated />
        <RoiKpiPopinDetails kpiValue=")" label=" " isFocus={false} hideInfoBox />
      </div>
    </div>
  );
}

export default RoiBpResultDetails;
